export default "__VITE_ASSET__D8CubhU3__"